<template>
  <div class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-row>
      <b-col cols="12" class="mb-2 mb-lg-4">
        <PageTitle class="mt-2" title="Sobre a empresa" />
      </b-col>
      <b-col cols="12"  class="mb-4">
        <div>
          <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=UFlMlyuysf0&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=32', 
            title: 'Sobre a empresa' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
          <a class="btn btn-success" href="https://api.construp.com.br/assets/Sobre a empresa.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
      </div>
      </b-col>
    </b-row>

    <b-row class="justify-content-sm-start justify-content-lg-start">
      <b-col cols="12">
        <p>
          <b-alert show variant="warning">
            <i class="fas fa-exclamation-triangle"></i>
            O layout abaixo é apenas uma simulação. No aplicativo real pode
            haver diferenças.
          </b-alert>
        </p>
      </b-col>

      <b-col v-if="whatClerkPermission()" cols="12" lg="5" class="form-group container">
        <label class="font-weight-bold">
          Ícone
          <b-button
            v-if="fields.icon"
            size="sm"
            variant="danger"
            class="ml-2"
            @click="removeFile('icon')"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </label>
        <div v-if="fields.icon">
          <b-img
            :src="`${getImagesAddressApp}${fields.icon}`"
            fluid
            width="70%"
          ></b-img>
        </div>
        <b-form-file
          v-else
          accept="image/*"
          browse-text="Selecionar"
          placeholder="Insira um icon para o app"
          v-model="imageSelected['icon']"
          @input="addImage('icon')"
        ></b-form-file>

        <div class="container ml-3 mt-5">
          <FakeAppFront
            :titleDinamic="fields.title"
            style="
              min-height: 800px;
              max-height: 800px;
              height: 800px;
              width: 50px;
            "
          />
        </div>
      </b-col>
      
      <b-col v-if="whatClerkPermission()" cols="12" lg="6" class="form-group container">
        <label class="font-weight-bold">
          Logo
          <b-button
            v-if="fields.logo"
            size="sm"
            variant="danger"
            class="ml-2"
            @click="removeFile('logo')"
          >
          <i class="fas fa-trash"></i>
        </b-button>
        </label>
        <div v-if="fields.logo">
          <b-img
            :src="`${getImagesAddressApp}${fields.logo}`"
            fluid
            width="70%"
          ></b-img>
        </div>

        <b-form-file
          v-else
          accept="image/*"
          browse-text="Selecionar"
          placeholder="Insira uma logo da sua empresa"
          v-model="imageSelected['logo']"
          @input="addImage('logo')"
        ></b-form-file>
        
        <div class="container ml-3">
          <FakeAppAbout
            class="prototypePhone marginTopFake"
            :titleDinamic="fields.title"
            :resumeDinamic="fields.resume"
            :subjectDinamic="fields.subject"
            style="
              min-height: 800px;
              max-height: 800px;
              height: 800px;
              width: 50px;
            "
            :header-menu-color="fieldsColor.menuHeaderColor.hex8"
            :background-color="fieldsColor.backgroundColor.hex8"
            :icon-color="fieldsColor.iconColor.hex8"
            :font-color="fieldsColor.fontColor.hex8"
            :video="fields.video"
          />
        </div>
      </b-col>

      <div class="col-md-12 marginTopText">
        <b-row v-if="whatClerkPermission()">
          <b-col cols="12" class="form-group">
            <label class="font-weight-bold">Título</label>
            <input
              required
              v-model="fields.title"
              class="form-control"
              @input="requiredFields.title = ''"
            />
            <error-message :errorMessage="requiredFields.title" />
          </b-col>
          <b-col cols="12" class="form-group">
            <label class="font-weight-bold">Resumo</label>
            <ckeditor
              v-model="fields.resume"
              :editor="editorSettings.type"
              :config="editorSettings.config"
              @input="requiredFields.resume = ''"
            />
            <error-message :errorMessage="requiredFields.resume" />
          </b-col>

          <b-col cols="12" class="form-group">
            <label class="font-weight-bold">Texto do assunto</label>
            <ckeditor
              v-model="fields.subject"
              :editor="editorSettings.type"
              :config="editorSettings.config"
            />
            <error-message :errorMessage="requiredFields.subject" />
          </b-col>

          <b-col cols="12" class="form-group">
            <label class="font-weight-bold">
              Imagem
              <b-button
                v-if="fields.image"
                size="sm"
                variant="danger"
                class="ml-2"
                @click="removeFile('image')"
              >
                <i class="fas fa-trash"></i>
              </b-button>
            </label>
            <div v-if="fields.image">
              <b-img
                :src="`${getImagesAddressApp}${fields.image}`"
                fluid
              ></b-img>
            </div>
            <b-form-file
              v-else
              accept="image/*"
              browse-text="Selecionar"
              placeholder="Insira uma imagem de 1920px de largura por 500px de altura"
              v-model="imageSelected['image']"
              @input="addImage('image')"
            ></b-form-file>
          </b-col>

          <b-col cols="12" class="form-group">
            <label class="font-weight-bold">Vídeo</label>
            <input
              type="text"
              class="form-control"
              id="video"
              v-model="fields.video"
              placeholder="URL do vídeo a ser exibido (Ex: https://youtube.com...)"
            />
          </b-col>

          <b-col  cols="12" class="mb-4 mt-3">
            <b-button variant="success" block @click="save()">
              <i class="fas fa-save mr-2"></i>
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-row>
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { mapActions, mapGetters, mapState } from 'vuex';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import PageTitle from '../../../components/PageTitle.vue';
import FakeAppAbout from '@/views/lojista/customizations/ChangeColor/FakeAppAbout.vue';
import FakeAppFront from '@/views/lojista/customizations/ChangeColor/FakeAppFront.vue';
import UploadAdapter from '../../../utils/UploadAdapterAxios.js';
import makeToast from '../../../mixins/makeToast';
import ErrorMessage from '../../../components/ErrorMessage.vue';
import VideoManual from '@/components/VideoManual.vue';

const UploadAdapterPlugin = (editor) => {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    const token = localStorage.getItem('token');
    return new UploadAdapter(loader, token);
  };
};

export default {
  name: 'CustomizationSocialMedias',
  mixins: [makeToast],
  components: { PageTitle, ErrorMessage, FakeAppAbout, FakeAppFront, VideoManual },
  data() {
    return {
      imageSelected: {},
      fields: {
        title: '',
        resume: '',
        subject: '',
        image: '',
        video: '',
        logo: '',
        icon: '',
      },
      fieldsColor: {
        menuHeaderColor: {},
        backgroundColor: {},
        iconColor: {},
        fontColor: {},
      },
      fileFieldsToExclude: {},
      requiredFields: {},
      editorSettings: {
        type: ClassicEditor,
        config: {
          extraPlugins: [UploadAdapterPlugin],
        },
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
    titleDinamic() {
      return this.fields.title;
    },
    resumeDinamic() {
      return this.fields.resume;
    },
  },
  mounted() {
    this.get();

    this.fileFieldsToExclude = {};
  },
  methods: {
    ...mapActions('shopkeeper', [
      'saveAboutCompany',
      'getAboutCompany',
      'getCustomization',
      'saveCustomization',
    ]),
    ...mapActions('files', ['uploadFile', 'deleteFile', 'uploadFileApiApp']),
    get() {
      this.$store.dispatch('startLoader');

      this.getAboutCompany(this.userTypeId())
        .then((response) => {
          this.fields = response.data.data || {};
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados sobre a empresa',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });

      this.getCustomization(this.userTypeId())
        .then((response) => {
          if (!response.data.data) return;
          this.handleColors(response.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    handleColors({ menuHeaderColor, backgroundColor, iconColor, fontColor }) {
      this.$set(this.fieldsColor.menuHeaderColor, 'hex8', menuHeaderColor);
      this.$set(this.fieldsColor.menuHeaderColor, 'hex', menuHeaderColor);

      this.$set(this.fieldsColor.backgroundColor, 'hex8', backgroundColor);
      this.$set(this.fieldsColor.backgroundColor, 'hex', backgroundColor);

      this.$set(this.fieldsColor.iconColor, 'hex8', iconColor);
      this.$set(this.fieldsColor.iconColor, 'hex', iconColor);

      this.$set(this.fieldsColor.fontColor, 'hex8', fontColor);
      this.$set(this.fieldsColor.fontColor, 'hex', fontColor);
    },
    save(msg = '') {
      const request = {
        userId: this.userTypeId(),
        ...this.fields,
      };

      this.$store.dispatch('startLoader');

      this.saveAboutCompany(request)
        .then(() => {
          if (msg != '') {
            this.makeToast('Sucesso', msg);
          } else {
            this.makeToast(
              'Sucesso',
              'Informações sobre a empresa salvas com sucesso'
            );
          }

          this.get();
          this.$root.$emit('valid-available-app');
          this.$root.$emit('valid-logo-about-app');
          this.$root.$emit('valid-icon-about-app');

          Object.keys(this.fileFieldsToExclude).forEach((key) => {
            this.deleteFile(this.fileFieldsToExclude[key]);
          });
        })
        .catch((error) => {
          this.handleErrorMessages(error.response.data.message);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    addImage(key) {
      if (!this.imageSelected[key]) return;

      const formData = new FormData();
      formData.append('file', this.imageSelected[key]);

      this.$store.dispatch('startLoader');

      this.uploadFileApiApp(formData)
        .then((response) => {
          this.fields[key] = response.data.data;
          this.save('Imagem inserida com sucesso!');
        })
        .catch(() => {
          this.fields[key] = '';

          this.makeToast(
            'Oops!',
            'Não foi possível inserir sua imagem, tente novamente!',
            'danger'
          );
        })
        .finally(() => {
          this.imageSelected[key] = null;
          this.$store.dispatch('endLoader');
        });
    },
    removeFile(key) {
      if (!this.fields[key]) return;

      const fileName = this.fields[key];

      this.fileFieldsToExclude[key] = fileName;

      this.fields[key] = '';
    },
    handleErrorMessages(errorMessages) {
      if (!errorMessages) return;

      Object.keys(errorMessages).forEach((key) => {
        this.$set(this.requiredFields, key, 'Campo obrigatório');
      });
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.CUSTOMIZACAO_EMPRESA
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style scoped>
.marginTopFake {
  margin-top: 60px;
}
.marginTopText {
  margin-top: -60px;
}
</style>